import { render, staticRenderFns } from "./SupportTicketDialogCalledBy.vue?vue&type=template&id=07a48fd0"
import script from "./SupportTicketDialogCalledBy.vue?vue&type=script&lang=js"
export * from "./SupportTicketDialogCalledBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports